import NotificationsProvider, { useNotifications } from './context';

export default NotificationsProvider;
export { useNotifications };
